module.exports = __webpack_public_path__ + "static/media/global_card3.58d17117.svg";